var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21833 1.21833C2.84277 -0.406111 5.48472 -0.406111 7.10917 1.21833L13 7.10917L18.8908 1.21833C20.5153 -0.406111 23.1572 -0.406111 24.7817 1.21833C26.4061 2.84277 26.4061 5.48472 24.7817 7.10917L18.8908 13L24.7817 18.8908C26.4061 20.5153 26.4061 23.1572 24.7817 24.7817C23.1572 26.4061 20.5153 26.4061 18.8908 24.7817L13 18.8908L7.10917 24.7817C5.48472 26.4061 2.84277 26.4061 1.21833 24.7817C-0.406111 23.1572 -0.406111 20.5153 1.21833 18.8908L7.10917 13L1.21833 7.10917C-0.406111 5.48472 -0.406111 2.84277 1.21833 1.21833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a7424533b302e34bc6d013b7255eedce.svg";
export { ForwardRef as ReactComponent };